<template>
  <div class="strage_wrapper">
    <div class="strage_box">
      <strageList :strageData="strageData" @loadMore="loadMore('more')" />
    </div>
  </div>
</template>

<script>
import { toast } from "assets/commonjs/toast";
import strageList from "./components/strageList";
import { setStore, getStore } from "assets/commonjs/storage";
export default {
  data() {
    return {
      pageNum: 0,
      pageSize: 5,
      companyId: 1,
      strageData: [],
      count: 1,
     
    };
  },
  components: {
    strageList
  },
  mounted(){
    this.pageNum = 0;
    this.init();
  },
  
  methods: {
    init() {
      this.getStrageData();
    },
    getStrageData(type) {
      let data = {
        pageNum: this.pageNum,
        pageSize: this.pageSize,
        companyId: this.companyId
      };
      this.$api.strageList.getStrageData(data).then(res => {
        if (res.data && res.data.code == 0) {
          let data = res.data.result;
            let ampClass;
            let productPramas = [];
            for (let i in data) {
              if (getStore("patternLabel") == "redGreen") {
                if (data[i].tendency == 0) {
                  ampClass = "red";
                } else {
                  ampClass = "green";
                }
              } else {
                if (data[i].tendency == 0) {
                  ampClass = "green";
                } else {
                  ampClass = "red";
                }
              }
           
              this.$set(data[i], "pro", ampClass);
                
            }
          if (type == "more") {
            if (res.data.result.length == 0) {
              toast("没有更多数据了");
            }
            this.strageData = this.strageData.concat(data);
          } else {
            this.strageData = data;
          }
        }
      });
    },
    loadMore(type) {
      this.pageNum += this.pageSize;
      this.getStrageData(type);
    }
  }
};
</script>

<style lang="scss" scoped>
@import "~assets/styles/mixin";
.strage_wrapper {
  background: #f0f1f5;
  padding-bottom: 0.5rem;
}
.strage_box {
  padding-top: 0.5rem;
}
</style>
